<template>
    <v-stepper v-model="step">
        <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">
                Cuentas contables
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2">
                Facturación total
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">Cobros del banco</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
            <v-stepper-content step="1">
                <v-card>
                    <v-col cols="12" md="12">
                        <v-text-field
                            outlined
                            v-model="year"
                            label="Año"
                            :rules="[(v) => !!v || 'Campo requerido']"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-autocomplete
                            outlined
                            v-model="opcion_totales"
                            :items="listado_totales"
                            item-text="option"
                            item-value="value"
                            label="Seleccionar tipo de total"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-file-input
                            outlined
                            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            label="File input"
                            v-model="file"
                            ref="myfile"
                        ></v-file-input>
                    </v-col>
                    <v-card-actions class="pt-3">
                        <v-btn color="success" large @click="importarExcel"
                            >Confirmar</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
                <v-card class="mb-12">
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-text-field
                                outlined
                                v-model="total_facturado"
                                label="Total facturado"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12">
                            <v-text-field
                                outlined
                                v-model="total_ventas"
                                label="Total ventas"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>

                <v-btn color="primary" @click="saveTotalFacturado">
                    Confirmar
                </v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
                <v-card class="mb-12">
                    <v-row>
                        <v-col cols="12" md="12">
                            <v-text-field
                                outlined
                                v-model="banco.ingresado"
                                label="Total ingresado"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12">
                            <v-text-field
                                outlined
                                v-model="banco.pagado"
                                label="Total pagado"
                            ></v-text-field>
                        </v-col>
                    </v-row>
                </v-card>

                <v-btn color="primary" @click="saveBanco"> Confirmar </v-btn>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
</template>
<script>
export default {
    props: ["id_empresa", "value"],
    data() {
        return {
            step: 1,
            year: 0,
            opcion_totales: null,
            file: null,
            listado_totales: [
                {
                    option: "Total 1",
                    value: "total1",
                },
                {
                    option: "Total 2",
                    value: "total2",
                },
            ],
            total_facturado: 0,
            total_ventas: 0,
            banco: {},
        };
    },
    watch: {
        value(val) {
            this.step = val;
        },
        step(val) {
            this.$emit("input", val);
        },
    },
    methods: {
        saveBanco() {
            let banco = {
                id_empresa: this.id_empresa,
                ingresado_banco: this.banco.ingresado,
                pagado_banco: this.banco.pagado,
            };

            axios.post(`api/update-cuenta-banco`, banco).then((res) => {
                this.$emit("close");
            });
        },
        saveTotalFacturado() {
            this.$emit("saveFacturado", {
                total_facturado: this.total_facturado,
                total_ventas: this.total_ventas,
            });
        },
        importarExcel() {
            let formData = new FormData();
            formData.append("file", this.file);
            formData.append("year", this.year);
            formData.append("total", this.opcion_totales);
            axios
                .post(`api/import-excel-cuentas/${this.id_empresa}`, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(
                    (res) => {
                        this.exitosas = res.data.exitoso;
                        this.$toast.success("Datos cargados con éxito");
                        this.step = 2;
                        this.$emit("refresh");
                    },
                    (err) => {
                        this.$toast.error("Error al obtener los datos");
                    }
                );
        },
    },
};
</script>
